import React, { useCallback } from 'react'
import styled, { css } from 'styled-components'

import Inline from '../../layout/Inline/Inline'
import type { FormComponent } from '../interfaces'
import Label from '../Label/Label'
import { SwitchRoot, SwitchThumb } from './Switch.styles'

export interface SwitchProps extends FormComponent<boolean> {
  'data-e2e'?: string
  defaultValue?: boolean
  hasInputHeight?: boolean
}

const StyledLabel = styled(Label)`
  margin-bottom: 0;
`

const StyledInline = styled(Inline)<{ $hasInputHeight?: boolean }>`
  ${props =>
    props.$hasInputHeight &&
    css`
      height: ${props => props.theme.dimensions.inputHeight};
    `}
`

const Switch = ({
  'data-e2e': dataE2e,
  className,
  defaultValue,
  disabled,
  helpText,
  hasInputHeight,
  label,
  name,
  onChange,
  required,
  value,
}: SwitchProps) => {
  const handleChange = useCallback(
    (checked: boolean) => {
      onChange?.({ name, value: checked })
    },
    [name, onChange]
  )

  return (
    <StyledInline
      alignment="center"
      className={className}
      $hasInputHeight={hasInputHeight}
      spacing="small"
    >
      <SwitchRoot
        checked={value}
        data-e2e={dataE2e}
        defaultChecked={defaultValue}
        disabled={disabled}
        id={name}
        onCheckedChange={handleChange}
        value={name}
      >
        <SwitchThumb />
      </SwitchRoot>

      {label && (
        <StyledLabel
          data-e2e={dataE2e ? `${dataE2e}--label` : undefined}
          helpText={helpText}
          htmlFor={name}
          required={required}
          text={label}
        />
      )}
    </StyledInline>
  )
}

export default Switch
